export default __webpack_public_path__ + "static/media/Filter.8e3b75c0.svg";